export const addressInitialValues = {
  address1: '',
  address2: '',
  city: '',
  country: '',
  country_code: '',
  province: '',
  province_code: '',
  zip: '',
}

export const InstanceTypes = [
  { label: 't3.small.search', value: 't3.small.search' },
  { label: 't3.medium.search', value: 't3.medium.search' },
  { label: 'C7g.large.search', value: 'C7g.large.search' },
  { label: 'C7g.xlarge.search', value: 'C7g.xlarge.search' },
  { label: 'C7g.2xlarge.search', value: 'C7g.2xlarge.search' },
  { label: 'C7g.4xlarge.search', value: 'C7g.4xlarge.search' },
  { label: 'C7g.8xlarge.search', value: 'C7g.8xlarge.search' },
  { label: 'C7g.12xlarge.search', value: 'C7g.12xlarge.search' },
  { label: 'C7g.16xlarge.search', value: 'C7g.16xlarge.search' },
  { label: 'M7g.large.search', value: 'M7g.large.search' },
  { label: 'M7g.xlarge.search', value: 'M7g.xlarge.search' },
  { label: 'M7g.2xlarge.search', value: 'M7g.2xlarge.search' },
  { label: 'M7g.4xlarge.search', value: 'M7g.4xlarge.search' },
  { label: 'M7g.8xlarge.search', value: 'M7g.8xlarge.search' },
  { label: 'M7g.12xlarge.search', value: 'M7g.12xlarge.search' },
  { label: 'M7g.16xlarge.search', value: 'M7g.16xlarge.search' },
  { label: 'R7g.medium.search', value: 'R7g.medium.search' },
  { label: 'R7g.large.search', value: 'R7g.large.search' },
  { label: 'R7g.xlarge.search', value: 'R7g.xlarge.search' },
  { label: 'R7g.2xlarge.search', value: 'R7g.2xlarge.search' },
  { label: 'R7g.4xlarge.search', value: 'R7g.4xlarge.search' },
  { label: 'R7g.8xlarge.search', value: 'R7g.8xlarge.search' },
  { label: 'R7g.12xlarge.search', value: 'R7g.12xlarge.search' },
  { label: 'R7g.16xlarge.search', value: 'R7g.16xlarge.search' },
  { label: 'R7gd.large.search', value: 'R7gd.large.search' },
  { label: 'R7gd.xlarge.search', value: 'R7gd.xlarge.search' },
  { label: 'R7gd.2xlarge.search', value: 'R7gd.2xlarge.search' },
  { label: 'R7gd.4xlarge.search', value: 'R7gd.4xlarge.search' },
  { label: 'R7gd.8xlarge.search', value: 'R7gd.8xlarge.search' },
  { label: 'R7gd.12xlarge.search', value: 'R7gd.12xlarge.search' },
  { label: 'R7gd.16xlarge.search', value: 'R7gd.16xlarge.search' },
]
